<template>
    <div class="m-onboard-header" color="primary">
        <div class="container d-flex justify-space-between m-onboard-header__container">
            <div class="m-onboard-header__stepper">
                <MOnboardStepper :current="current" :steps="steps"/>
            </div>
            <div class="m-onboard-header-buttons">
                <div justify="center" class="close-wrapper" v-if="$vuetify.breakpoint.mdAndUp" >
                    <v-btn v-if="$vuetify.breakpoint.mdAndUp" @click.stop="dialog = true" class="m-onboard-header__btn" dark
                           icon>
                        <v-icon>close</v-icon>
                    </v-btn>

                    <v-dialog
                            v-model="dialog"
                            max-width="900"
                    >
                        <v-card class="px-4 py-4">
                            <e-typography-heading-3>Möchten Sie die ersten Schritte wirklich verlassen?</e-typography-heading-3>
                            <v-layout>
                                <v-flex pt-4 pb-4>
                                    <e-typography-body-small>
                                        Sie können die ersten Schritte jeder Zeit erneut starten.
                                    </e-typography-body-small>
                                </v-flex>
                            </v-layout>


                            <v-card-actions>
                                <v-layout>
                                    <v-flex xs-12>
                                        <e-button-secondary v-if="$vuetify.breakpoint.mdAndUp" @click="dialog = false" class="m-onboard-header__btn" dark>Abbrechen</e-button-secondary>
                                    </v-flex>
                                    <v-flex xs-12 pl-4 class="m-onboard-header-buttons-actions">
                                        <e-button-primary v-if="$vuetify.breakpoint.mdAndUp" @click="gotoDashboard()" class="m-onboard-header__btn" dark>Beenden</e-button-primary>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MOnboardStepper from "@modules/onboards/concrete/m-onboard-stepper";
    import ETypographyBold from "@elements/typography/e-typography-bold";
    import EButtonPrimary from "../../../elements/buttons/theme/e-button-primary";
    import ETypographyHeading3 from "../../../elements/typography/e-typography-heading-3";
    import ETypographyBodySmall from "../../../elements/typography/e-typography-body-small";

    export default {
        name: "m-onboard-header",
        components: {
            ETypographyBodySmall,
            ETypographyHeading3,
            EButtonPrimary,
            ETypographyBold,
            MOnboardStepper,
        },
        data () {
            return {
                dialog: false,
            }
        },
        props: {
            steps: {
                type: Array,
                default: []
            },
            current: {
                type: Number,
                default: 0
            }
        },
        methods: {
            next() {
                this.$emit('next')
            },
            gotoDashboard() {
                this.$store.dispatch('onboardings/setOpenState', false)
                this.redirect(this.nav.dashboard.index.name);
            },
        }
    }
</script>

<style lang="scss">
    .m-onboard-header {
        position: fixed;
        width: 100%;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--v-primary-base);

        @include media(md) {
            position: fixed;
            top: 0;
            z-index: 0;
            width: calc(100% - 3.0rem);
            height: 4rem;
        }

        .container {
            padding: .5rem 0;
            justify-content: space-between;

            .m-onboard-header-buttons {
                flex: 0 1 auto!important;

                .close-wrapper{
                    order: 2;
                }
                .m-onboard-step-buttons{
                    order: 1;
                }

                .v-btn.e-button {
                    @include media(lg) {
                        width: auto;
                    }
                }
            }
            @include media(md) {
                padding: 0;
                padding-left: 1rem;
            }
        }

        &__stepper {
            background: var(--v-primary-base);
        }

        //TODO: Add Buttons to Mobile Onboarding Menu
        &__btn-next {
            position: fixed;
            right: 15vw;
            top: 1.3rem;

            @include media(md) {
                position: absolute;
                top: 70vh;
                left: 1rem;
            }
            @include updatedMedia(sm) {
                position: absolute;
                top: 70vh;
                left: 1rem;
            }
        }

        .e-button {
            @include media(md) {
                position: absolute;
                width: 90vw;
                top: 25vh;
                left: 2rem;
            }
            @include updatedMedia(sm) {
                position: absolute;
                top: 45vh;
                left: .5rem;
            }
        }

        &__btn-skip {
            .e-typography-bold {
                padding-right: 1rem;
                cursor: pointer;
                font-size: 1rem;
                color: var(--v-white);

                @include media(md) {
                    color: var(--v-tertiary-base);
                }
            }

            @include updatedMedia(sm) {
               display: none;
            }
        }
    }
    .m-onboard-header-buttons-actions {
        display: contents;

        @include media(lg) {
            display: block;
        }
    }
</style>